module.exports = __webpack_public_path__ + "img/158.87bf7246.jpg";